export default {"src":"/_next/static/media/ic_login_line.4d40d82a.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};